import { clone } from 'lodash';
import * as constants from '../constants-types/constants';
import { SortType, SortDirection } from '../constants-types/Enums';
import { FilterInfo, XFilterType } from './FilterInfo.model';
import { SortInfo } from './SortInfo.model';

// TODO: If there're no methods on this and all the properties are public
// can this just be a plain object?
export class PageState {
    maxResults: number;

    constructor(
        public resultsPerPage: number = constants.tableDefaultResultsPerPage,
        public currentPageNumber: number = 1
    ) {}
}

export class SearchState {
    // This is a sorted array of properties and ascending
    constructor(
        public pageState = new PageState(),
        public filterState: FilterInfo[] = [],
        public sortingState: SortInfo[] = []
    ) {}

    private clonePageState(): PageState {
        const pageState = new PageState();
        pageState.maxResults = this.pageState.maxResults;
        pageState.resultsPerPage = this.pageState.resultsPerPage;
        pageState.currentPageNumber = this.pageState.currentPageNumber;
        return pageState;
    }

    private cloneSelf(): SearchState {
        return new SearchState(
            this.clonePageState(),
            clone(this.filterState),
            clone(this.sortingState)
        );
    }

    setPageSize(size: number): SearchState {
        const newSearchState = this.cloneSelf();
        newSearchState.pageState.resultsPerPage = size;
        return newSearchState;
    }

    setPage(page: number): SearchState {
        const newSearchState = this.cloneSelf();
        newSearchState.pageState.currentPageNumber = page;
        return newSearchState;
    }

    private mostRecentSort(): SortInfo {
        return this.sortingState[0];
    }

    addSort(type: SortType, direction?: SortDirection): SearchState {
        const newSearchState = this.cloneSelf();

        if (this.mostRecentSort() && this.mostRecentSort().sortType === type) {
            if (direction) {
                this.mostRecentSort().direction = direction;
            } else {
                this.mostRecentSort().direction =
                    this.mostRecentSort().direction === SortDirection.Ascending
                        ? SortDirection.Descending
                        : SortDirection.Ascending;
            }
        } else {
            newSearchState.sortingState = newSearchState.sortingState.filter(
                (sortInfo) => sortInfo.sortType !== type
            );
            // Most recently added sort is always first
            newSearchState.sortingState.unshift(
                new SortInfo(type, direction || SortDirection.Ascending)
            );
        }
        return newSearchState;
    }

    removeSort(type: SortType): SearchState {
        const newSearchState = this.cloneSelf();
        newSearchState.sortingState = newSearchState.sortingState.filter(
            (sortInfo) => sortInfo.sortType !== type
        );
        return newSearchState;
    }

    clearSort() {
        const newSearchState = this.cloneSelf();
        newSearchState.sortingState = [];
        return newSearchState;
    }

    // TODO - the next two methods feel a little redundant and confusfing - perhaps
    // have addFilter and resetFilters to make the clear explicit
    setFilter(type: FilterInfo): SearchState {
        const newSearchState = this.cloneSelf();
        newSearchState.filterState = [];
        return newSearchState.addFilter(type);
    }

    addFilter(filter: FilterInfo): SearchState {
        const newSearchState = this.cloneSelf();
        newSearchState.filterState = newSearchState.filterState.filter((f) =>
            filter.canCoexist(f)
        );
        newSearchState.filterState.push(filter);
        return newSearchState;
    }

    addFilters(filters: FilterInfo[]): SearchState {
        return filters.reduce(
            (searchState, filter) => searchState.addFilter(filter),
            this as SearchState
        );
    }

    removeFilter(filter: FilterInfo): SearchState {
        const newSearchState = this.cloneSelf();
        newSearchState.filterState = newSearchState.filterState.filter(
            (filterInfo) => filter.canCoexist(filterInfo)
        );
        return newSearchState;
    }

    removeFiltersOfType(filterType: XFilterType) {
        const newSearchState = this.cloneSelf();
        newSearchState.filterState = newSearchState.filterState.filter(
            (filterInfo) => filterType !== filterInfo.type
        );
        return newSearchState;
    }
}
